<!-- 产品图片 -->
<template>
    <div
        v-if="componentsData.type == 19"
        :style="`margin: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;`"
    >
        <!-- 轮播 -->
        <div
            v-if="componentsData.content.style_set == 1"
            class="swiper-container"
            :style="
                componentsData.content.version
                    ? `border-radius: ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px;`
                    : `border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`
            "
        >
            <Carousel radius-dot>
                <CarouselItem
                    v-for="(item, index) of componentsData.content.imgList"
                    :key="index"
                    class="img-div1"
                >
                    <img
                        v-if="item.value"
                        class="wh100"
                        :src="item.picview"
                        :style="
                            componentsData.content.version
                                ? `border-radius: ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px;`
                                : `border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`
                        "
                    />
                </CarouselItem>
            </Carousel>
        </div>
        <!-- 平铺 -->
        <div
            v-else-if="componentsData.content.style_set == 2"
            class="img-div2"
            :style="`border-radius: ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px;`"
        >
            <imgStyle
                class="h100"
                :imageData="componentsData"
                :imgList="[]"
            ></imgStyle>
        </div>
        <!-- 单张预览 -->
        <div
            v-else
            class="img-div3"
            :style="`border-radius: ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px;`"
        ></div>
    </div>
</template>

<script>
import imgStyle from "@/components/imgStyle/imgStyle.vue";
export default {
    components: {
        imgStyle,
    },
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        bg_color: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.swiper-container {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    z-index: 1;
}
.wh100 {
    width: 100%;
    height: 225px;
    min-height: 225px;
    max-height: 225px;
}
.img-div1 {
    height: 225px;
    min-height: 225px;
    max-height: 225px;
    border: 1px solid #ccc;
    background-color: #fff;
}
.img-div2 {
    height: 260px;
    background-color: #fff;
}
.img-div3 {
    height: 260px;
    width: 100%;
    border: 1px solid #ccc;
    background-color: #fff;
}
</style>